/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import o from"../../Color.js";const r=new o("white"),n=new o([255,255,255,0]);function t(o){return 0===o.r&&0===o.g&&0===o.b}export{t as isBlack,n as transparentWhite,r as white};
